import * as _ from 'lodash'
import { ElementProperties, Variable, VBoolean, Checkbox, Details, Div, H2, Header, Label, Span, Summary, all, if as _if } from 'alkali'
import TextInputControl from 'components/generic/TextInputControl'
import { invalid } from 'components/extract/Inputs'
import TextAreaControl from 'components/generic/TextAreaControl'
import * as view from 'icons/notes-paper-text.svg'
import Icon from 'components/Icon'
import VAbstractSource, { validYear } from './model/AbstractSource'
import { parseTaggedSentences } from './model/Abstract'
import StudyDesignButton from 'components/extract/StudyDesignButton'
import { orValidation, notEmptyFn } from './model/validation'

const invalidity = (cfg, invalid) => {
	const err = invalid.to(errs => errs ? (errs[0] || 'Please enter valid value') : '')
	return {
		...cfg,
		title: cfg.title || err,
		classes: {
			'invalid-field': invalid
		}
	}
}

interface EditAbstractOpts extends ElementProperties<EditAbstract> {
	abstractSource: VAbstractSource,
	edit: VBoolean
	allToggle: VBoolean
	debug?: boolean
}

/**
 * Editable abstract view, updates the StudySummary AbstractSource
 */
export default class EditAbstract extends Div('.edit-abstract') {
	created(props: EditAbstractOpts) {
		const src = props.abstractSource
		//const curSource = new Variable<AbstractSource>(props.abstractSource.valueOf())
		const edit = props.edit || new Variable(false)
		const attribution = all([src.property('Acronym'), src.property('Authors')])
		const eitherNotEmpty = attribution.to(orValidation(notEmptyFn, notEmptyFn))
		props.content = edit.to(edit => [
			Header([
				H2([
					Div('.abstract-metadata-row.flex-row', [
						Div('.abstract-year', [
							TextInputControl(invalidity({
								id: 'abstract-year-input',
								placeholder: 'year',
								value: src.property('PublicationYear'),
							}, invalid(src.property('PublicationYear'), src.property('PublicationYear').to(validYear))))
						]),
						Div('.abstract-attribution.flex-row', [
							Div('.abstract-acr', { title: 'Acronym' }, [
								TextInputControl({
									id: 'abstract-acr-input',
									placeholder: 'ACRONYM',
									value: src.property('Acronym'),
								})
							]),
							Div('.abstract-authors-label', [Label({ for: 'abstract-authors-input' }, 'Author:')]),
							Div('.abstract-authors', { title: 'Authors (comma delimited)' }, [
								TextInputControl(invalidity({
									id: 'abstract-authors-input',
									placeholder: 'Surname1 AB',
									value: src.property('Authors'),
									//validation: all([src.property('acronym'), src.property('authors')], composeValidateFn(notEmptyFn, notEmptyFn))
								}, invalid(attribution, eitherNotEmpty, true)))
							]),
						]),
						Div('.abstract-designs', [
							new StudyDesignButton({ designs: src.property('Designs') })
						])
					]),
					Div('.flex-row', [
						Div('.abstract-source', [
							TextInputControl({
								id: 'abstract-source-input',
								placeholder: 'publication source',
								value: src.property('Source')
							})
						]),
						Div('.abstract-doi', [
							TextInputControl({
								id: 'abstract-doi-input',
								placeholder: 'DOI',
								value: src.property('DOI')
							})
						]),
						Div('.abstract-fulltext', [
							TextInputControl({
								id: 'abstract-fulltext-input',
								placeholder: 'full text url',
								value: src.property('FullTextURL')
							})
						])
					]),
					Div('.flex-row', [
						Div([Label({ for: 'abstract-title-input' }, 'Title:')]),
						Div('.abstract-title', [
							TextInputControl(invalidity({
								id: 'abstract-title-input',
								value: src.property('Title'),
							}, invalid(src.property('Title'))))
						]),
						Div([Icon('.clickable', {
							icon: view,
							title: 'Return to abstract view',
							onclick() {
								// parse sentences
								src.put({
									...src.valueOf(),
									sentences: parseTaggedSentences(src.valueOf().Abstract)
								})
								props.edit.put(!props.edit.valueOf())
							}
						})])

					])
				])
			]),
			...(props.debug ? [
				Details([
					Summary('Debug'),
					Div([Span('Toggle DocSeach annotations'), Checkbox(props.allToggle)]),
				])
			] : []),
			Div('.abstract-form', [
				Div('.abstract-text.flex-row', [
					TextAreaControl({
						cols: 75, rows: 10
					}, src.property('Abstract'))
				])
			])
		])
	}
}